<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="userDetails">
          <h1>ویرایش پروفایل</h1>
          <BRow class="py-2 py-md-3 justify-content-center">
            <BCol justify-center cols="auto">
              <input
                @change="convertImageFileToBase64"
                ref="avatarPicker"
                type="file"
                name="avatar"
                id="avatar"
                class="hidden"
                accept="image/*"
              />
              <BButton
                variant="transparent"
                @click="openAvatarPicker"
                type="button"
              >
                <div
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <BAvatar :src="handleAvatarImage" size="7rem"></BAvatar>
                  <p class="mt-2 font-weight-bolder">
                    {{ defaultName }}
                  </p>
                  <p>
                    {{ userDetails.scheduleMasterRegularTitle }}
                  </p>
                </div>
              </BButton>
            </BCol>
          </BRow>
          <b-row class="p-2">
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="نام کامل" label-for="fullName">
                  <b-form-input
                    id="fullName"
                    v-model="userDetails.fullName"
                    trim
                    placeholder="نام کاربر"
                  />
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="شماره همراه" label-for="mobile">
                  <b-form-input
                    id="mobile"
                    v-model="userDetails.mobile"
                    trim
                    placeholder="0912..."
                  />
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12">
              <b-form @submit.prevent>
                <b-form-group label="ایمیل" label-for="email">
                  <b-form-input
                    id="email"
                    v-model="userDetails.email"
                    trim
                    placeholder="john@doe.com"
                  />
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12">
              <div class="w-100 d-flex align-items-center justify-content-end">
                <b-button
                  @click="updateUserByToken"
                  type="button"
                  variant="primary"
                >
                  بروزرسانی
                </b-button>
              </div>
            </b-col>
            <hr class="my-2 w-100" />
            <b-col cols="12">
              <h3>تغییر رمز عبور</h3>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="رمز عبور" label-for="password">
                  <b-form-input
                    type="password"
                    name="password"
                    id="password"
                    v-model="passwordDetails.newPass"
                    trim
                    placeholder="1234"
                  />
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="تکرار رمز عبور" label-for="rePassword">
                  <b-form-input
                    type="password"
                    name="rePassword"
                    id="rePassword"
                    v-model="passwordDetails.newPassConfirm"
                    trim
                    placeholder="1234"
                  />
                </b-form-group>
              </b-form>
              <small v-if="isRenderingConfirmPassError" class="text-danger">
                رمز عبور و تکرار آن باید یکسان باشند!
              </small>
            </b-col>
            <b-col cols="12">
              <div class="w-100 d-flex align-items-center justify-content-end">
                <b-button
                  @click="updateUserPasswordByToken"
                  type="button"
                  variant="primary"
                  :disabled="isPasswordButtonDisabled"
                >
                  تغییر رمز عبور
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  mounted() {
    this.getUserByToken();
  },
  data() {
    return {
      isLoading: false,
      userDetails: null,
      defaultName: null,
      avatarPreview: null,
      passwordDetails: {
        newPass: null,
        newPassConfirm: null,
      },
    };
  },
  methods: {
    convertImageFileToBase64(event) {
      if (event.target.files && event.target.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        this.avatarPreview = URL.createObjectURL(event.target.files[0]);
        reader.onload = () => {
          this.userDetails.selfieFileData = reader.result.split(",")[1];
        };
      }
    },
    openAvatarPicker() {
      this.$refs?.avatarPicker?.click();
    },
    async getUserByToken() {
      try {
        this.isLoading = true;
        let _this = this;
        let getUserByToken = new GetUserByToken(_this);
        getUserByToken.fetch((res) => {
          _this.userDetails = res.data;
          _this.defaultName = res.data.fullName;
          _this.avatarPreview = null;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateUserByToken() {
      try {
        if (!this.avatarPreview) {
          this.userDetails.selfieFileData = null;
        }
        this.isLoading = true;
        let _this = this;
        let updateUserByToken = new UpdateUserByToken(_this);
        updateUserByToken.setRequestParamDataObj(_this.userDetails);
        await updateUserByToken.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "بروز شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "اطلاعات شما با موفقیت بروز شد.",
              },
            });
            _this.getUserByToken();
          } else {
            if (
              res.errors &&
              (res.errors["Email"] == "DuplicateRecord" ||
                res.errors["Mobile"] == "DuplicatedRecord")
            ) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مشکلی پیش آمد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: "شماره همراه یا ایمیل تکراری است",
                },
              });
            } else {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مشکلی پیش آمد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.errors || "لطفا دوباره امتحان کنید.",
                },
              });
            }
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateUserPasswordByToken() {
      try {
        this.isLoading = true;
        let _this = this;
        let changePasswordByUser = new ChangePasswordByUser(_this);
        changePasswordByUser.setRequestParam(_this.passwordDetails);
        await changePasswordByUser.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "بروز شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "رمز عبور شما با موفقیت بروز شد.",
              },
            });
            _this.passwordDetails = {
              newPass: null,
              newPassConfirm: null,
            };
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره امتحان کنید.",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    handleAvatarImage() {
      if (this.avatarPreview) {
        return this.avatarPreview;
      } else if (this.userDetails.selfieFileData) {
        return `${this.baseUrl}/${this.userDetails.selfieFileData}`;
      }
    },
    isPasswordButtonDisabled() {
      if (
        this.passwordDetails &&
        this.passwordDetails.newPass &&
        this.passwordDetails.newPassConfirm &&
        this.passwordDetails.newPass == this.passwordDetails.newPassConfirm
      ) {
        return false;
      }
      return true;
    },
    isRenderingConfirmPassError() {
      if (
        this.passwordDetails &&
        this.passwordDetails.newPass &&
        this.passwordDetails.newPassConfirm &&
        this.passwordDetails.newPass != this.passwordDetails.newPassConfirm
      ) {
        return true;
      }
      return false;
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BOverlay,
    BAvatar,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BOverlay,
  BAvatar,
} from "bootstrap-vue";
import {
  GetUserByToken,
  UpdateUserByToken,
  ChangePasswordByUser,
} from "@/libs/Api/Users";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
